import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 0px',
    height: 'auto',
  },
  title: {
    fontSize: 40,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    textAlign: 'left',
    alignSelf: 'flex-start',
  },
  chipText: {
    fontSize: '18px',
    paddingLeft: '12px',
    paddingRight: '12px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  description: {
    color: '#777777',
    textAlign: 'left',
  },
  labelWrapper: {
    display: 'flex',
  },
  label: {
    color: theme.palette.secondary.main,
  },
  chipText: {
    fontSize: '18px',
    paddingLeft: '12px',
    paddingRight: '12px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  emailInput: {
    fontSize: '18px',
    marginLeft: '10px',
  },
  chip: {
    margin: '0px 10px',
  },
}));

const { Group, Label, Control } = Form;

const genderList = ['Male', 'Female', 'Prefer not to answer', 'Other'];
const ethnicityList = [
  'American Indian or Alaskan Native',
  'Asian / Pacific Islander',
  'Black or African American',
  'Hispanic',
  'White / Caucasian',
  'Prefer not to answer',
  'Multiple ethnicity / Other (Please Specify)',
];
const sexualOrientationList = [
  'Asexual/Aromantic',
  'Pansexual, Demisexual or Omnisexual',
  'Bisexual',
  'Queer',
  'Gay/Lesbian',
  'Heterosexual/Straight',
  'Prefer not to answer',
  'Other',
];

const OptionalQuestion = (props) => {
  const classes = useStyles();
  const { formInfo, setFormInfo } = props;

  const [showOther, setShowOther] = useState(false);

  const handleForm = (key, value) => {
    const newFormInfo = { ...formInfo, [key]: value };
    setFormInfo(newFormInfo);
  };

  const handleAddTeammate = (chip) => {
    if (formInfo.teammates.length >= 3) {
      return;
    }
    setFormInfo((prevFormInfo) => ({
      ...prevFormInfo,
      teammates: [...prevFormInfo.teammates, chip],
    }));
  };
  const handleRemoveTeammate = (chip, index) => {
    setFormInfo((prevFormInfo) => {
      let teammates = prevFormInfo.teammates.filter(
        (teammate) => teammate !== chip
      );
      return { ...prevFormInfo, teammates };
    });
  };

  return (
    <div className={classes.root}>
      <p className={classes.title}>Optional Questions</p>
      <Form style={{ marginBottom: '20px' }}>
        <Group className="mt-2 mb-3">
          <Label className={classes.labelWrapper}>
            <Typography variant="h3" className={classes.label}>
              Do you already have a team?
            </Typography>
          </Label>
          <p className={classes.description}>
            Please enter your teammates' emails (3 max). If you don't have a
            team, don't worry! There will be plenty of ways for you to find a
            team.
          </p>
        </Group>
        <ChipInput
          value={formInfo.teammates}
          onAdd={handleAddTeammate}
          onDelete={handleRemoveTeammate}
          placeholder="sally@email.com"
          fullWidth
          classes={{
            input: classes.emailInput,
            chip: classes.chip,
          }}
          chipRenderer={({ value, text, handleDelete }, index) => (
            <Chip
              variant="outlined"
              color="primary"
              size="medium"
              onDelete={handleDelete}
              label={<div className={classes.chipText}>{value}</div>}
            />
          )}
        />
      </Form>

      <p className={classes.description}>
        The following information will only be viewed as a collective to improve
        our outreach and ensure future events are accessible to everyone. They
        will not influence your candidacy.
      </p>
      <Form>
        <Group className="mt-2 mb-3">
          <Label className={classes.labelWrapper}>
            <Typography variant="h3" className={classes.label}>
              What is your race/ethnicity?
            </Typography>
          </Label>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <Select
              value={
                ethnicityList.includes(formInfo.raceEthnicity) ||
                formInfo.raceEthnicity == ''
                  ? formInfo.raceEthnicity
                  : 'Multiple ethnicity / Other (Please Specify)'
              }
              onChange={(e) => {
                handleForm('raceEthnicity', e.target.value);
                if (
                  e.target.value !==
                  'Multiple ethnicity / Other (Please Specify)'
                ) {
                  setShowOther(false);
                } else {
                  setShowOther(true);
                }
              }}>
              {ethnicityList.map((ethnicity) => (
                <MenuItem value={ethnicity} key={ethnicity}>
                  {ethnicity}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Group>
        {showOther && (
          <Group className="mt-2 mb-3">
            <Label className={classes.labelWrapper}>
              <Typography variant="h3" className={classes.label}>
                Please specify
              </Typography>
            </Label>
            <Control
              type="text"
              placeholder="ie. Other (Please Specify)"
              onChange={(e) => {
                handleForm('raceEthnicity', e.target.value);
              }}
            />
          </Group>
        )}
        <Group className="mb-3">
          <Label className={classes.labelWrapper}>
            <Typography variant="h3" className={classes.label}>
              What is your gender?
            </Typography>
          </Label>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <Select
              value={formInfo.gender}
              onChange={(e) => {
                handleForm('gender', e.target.value);
              }}>
              {genderList.map((gender) => (
                <MenuItem value={gender} key={gender}>
                  {gender}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Group>
        <Group>
          <Label className={classes.labelWrapper}>
            <Typography variant="h3" className={classes.label}>
              What is your sexual orientation?
            </Typography>
          </Label>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <Select
              value={formInfo.sexualOrientation}
              onChange={(e) => {
                handleForm('sexualOrientation', e.target.value);
              }}>
              {sexualOrientationList.map((sexualOrientation) => (
                <MenuItem value={sexualOrientation} key={sexualOrientation}>
                  {sexualOrientation}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Group>
      </Form>
    </div>
  );
};

export default OptionalQuestion;
